module.exports = __webpack_public_path__ + "img/jason_k_williamson_title.850d1e50.svg";